import { useNavigate } from "react-router-dom";
import { NotFoundPageProps } from "./types";
import { NotFoundPageView } from "./view";

export const NotFoundPage = (props: NotFoundPageProps) => {
	const navigate = useNavigate();

	return <NotFoundPageView goToInitialPage={() => navigate("/")} />;
};
